module.exports = __webpack_public_path__ + "static/media/ideal-mobile.aec25517.svg";